import React from "react";
import { Text, TextStyle, StyleProp, StyleSheet } from "react-native";

type NormalTextProps = {
  text: string;
  style?: StyleProp<TextStyle>;
  numberOfLines?: number;
  fontWeight?: "700" | "600" | "500" | "400";
};

const NormalText: React.FC<NormalTextProps> = ({
  text,
  style,
  numberOfLines = 100,
  fontWeight = "500",
}) => {
  return (
    <Text
      style={[
        styles.baseText,
        fontWeight === "400" && styles.font400,
        fontWeight === "500" && styles.font500,
        fontWeight === "600" && styles.font600,
        fontWeight === "700" && styles.font700,
        style,
      ]}
      numberOfLines={numberOfLines}
    >
      {text}
    </Text>
  );
};

const styles = StyleSheet.create({
  baseText: {
    fontSize: 16,
    color: "#000",
  },
  font400: {
    fontFamily: "Urbanist400",
  },
  font500: {
    fontFamily: "Urbanist500",
  },
  font600: {
    fontFamily: "Urbanist600",
  },
  font700: {
    fontFamily: "Urbanist700",
  },
});

export default NormalText;
